import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage";
import { CalendarModule } from 'primeng/primeng';
import { UtilService } from "../../components/common/utils/util.service";
import { SiniestrosComponent } from "./siniestros.component";
import { CabeceraModule } from "../../components/common/cabecera/cabecera.module";
import { SiniestrosService } from "./siniestros.service";
import { SiniestralidadSiniestrosComponent } from "./siniestralidad-siniestros.component";
import {
    FilterPolizaSiniestrosPipe,
    FilterRamoSiniestrosPipe,
    FilterPlacaSiniestrosPipe,
    FilterEstadoVehSiniestrosPipe,
    FilterEstadoCasSiniestrosPipe,
    FilterEstadoO2OSiniestrosPipe,
    FilterDireccionSiniestrosPipe,
    FilterDiagnosticoSiniestrosPipe,
    FilterPacienteSiniestrosPipe,
    FilterBienAfectadoSiniestrosPipe,
    FilterBTipoReclamoSiniestrosPipe,
    FilterEstadoOtrosRamosSiniestrosPipe
} from "./siniestros-filter.component";
import { TrackingVehiculoComponent } from "./tracking/tracking-siniestros-vehiculos.component";
import { TrackingO2OComponent } from "./tracking/tracking-siniestros-o2o.component";
import { RerporteSiniestroVehiculoComponent } from "./reporteSiniestros/siniestro-reporte-vehiculo.component";
import { RerporteSiniestroViviendaComponent } from "./reporteSiniestros/siniestro-reporte-vivienda.component";
import { TrackingViviendaComponent } from "./tracking/tracking-siniestros-vivienda.component";
import { TrackingOtrosRamosComponent } from "./tracking/tracking-siniestros-otros-ramos.component";
import { SiniestroscorporarivoComponent } from "../siniestroscorporativos/siniestroscorporativos.component";
import { CabeceracorporativoModule } from "../../components/common/cabeceracorporativo/cabeceracorporativo.module";
import { SiniestroscorporativoService } from "../siniestroscorporativos/siniestroscorporativo.service";
import { RerporteSiniestroVamO2OComponent } from "./reporteSiniestros/siniestro-reporte-vamO2O.component";
import { FilterDocumentos } from "./reporteSiniestros/siniestro-reporte-vamO2O.pipe";
import { FilterDocumentosTracking } from "./tracking/tracking-siniestros-o2o.pipe";
import { FilterDocumentosTrackingVH } from "./tracking/tracking-siniestros-vehiculos.pipe";
@NgModule({
    declarations: [
        SiniestrosComponent,
        SiniestralidadSiniestrosComponent,
        FilterPolizaSiniestrosPipe,
        FilterRamoSiniestrosPipe,
        FilterPlacaSiniestrosPipe,
        FilterEstadoVehSiniestrosPipe,
        FilterEstadoCasSiniestrosPipe,
        FilterEstadoO2OSiniestrosPipe,
        FilterDireccionSiniestrosPipe,
        FilterDiagnosticoSiniestrosPipe,
        FilterPacienteSiniestrosPipe,
        FilterBienAfectadoSiniestrosPipe,
        FilterBTipoReclamoSiniestrosPipe,
        FilterEstadoOtrosRamosSiniestrosPipe,
        TrackingVehiculoComponent,
        TrackingO2OComponent,
        TrackingViviendaComponent,
        TrackingOtrosRamosComponent,
        RerporteSiniestroVehiculoComponent,
        RerporteSiniestroViviendaComponent,
        RerporteSiniestroVamO2OComponent,
        SiniestroscorporarivoComponent,
        FilterDocumentos,
        FilterDocumentosTracking
        ],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        Ng2Webstorage,
        CalendarModule,
        CabeceraModule,
        CabeceracorporativoModule
    ],
    exports: [RerporteSiniestroVehiculoComponent, RerporteSiniestroViviendaComponent,RerporteSiniestroVamO2OComponent],
    providers: [UtilService, SiniestrosService,SiniestroscorporativoService]
})

export class SiniestrosModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestros/siniestros.model.ts